module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-wood-walnut.7ce0ecc0.jpg";